var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow61(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_25720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4719 28.7524L31.2469 16.528C30.5433 15.824 29.4014 15.824 28.6969 16.528L26.1583 19.0666L29.3786 22.287C30.127 22.0341 30.9851 22.2037 31.5817 22.8003C32.181 23.4006 32.3495 24.2661 32.0905 25.0168L35.194 28.1205C35.9449 27.8618 36.8112 28.0291 37.4109 28.6298C38.2491 29.4676 38.2491 30.8255 37.4109 31.6639C36.5726 32.5024 35.2147 32.5024 34.3759 31.6639C33.7454 31.0328 33.5897 30.1069 33.9088 29.3303L31.0146 26.436L31.0142 34.0525C31.224 34.1563 31.4157 34.2933 31.5817 34.4583C32.4198 35.2961 32.4198 36.6541 31.5817 37.4931C30.7433 38.3312 29.3848 38.3312 28.5476 37.4931C27.7095 36.6541 27.7095 35.2962 28.5476 34.4584C28.7485 34.2575 28.9872 34.0983 29.2499 33.9902V26.3027C28.9868 26.1952 28.7479 26.036 28.5476 25.8344C27.9126 25.2003 27.7599 24.2685 28.0853 23.4888L24.9108 20.3139L16.5283 28.6959C15.8239 29.4006 15.8239 30.5426 16.5283 31.2467L28.7536 43.4714C29.4574 44.1755 30.599 44.1755 31.3037 43.4714L43.4718 31.3035C44.176 30.5991 44.1761 29.4565 43.4719 28.7524Z",
    fill: "#DE4C36"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_25720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow61);
export default __webpack_public_path__ + "static/media/row-6-1.4595294d6a0f5749ddbf17381878104d.svg";
export { ForwardRef as ReactComponent };